<template>
  <div>
    <v-toolbar color="#02092E" dark >
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

      <a href="https://covatic.com/" target="_blank" rel="noopener noreferrer">
        <v-img :src="cvcIcon" contain width="150px" height="50px" />
      </a>

      <v-toolbar-title>Insights Portal</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->

      <div class="d-inline-flex">
        <v-btn @click="showLogoutDialog()" light>
          Log out
        </v-btn>
      </div>

      <template v-slot:extension>
        <!-- <v-tabs v-model="tab" align-with-title> -->
        <v-tabs align-with-title>
          <v-tabs-slider color="white"></v-tabs-slider>

          <v-tab
            v-for="item in tabs"
            :key="`tab-${item.name}`"
            @click="$router.push({ name: item.link })"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <!-- <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item"
      >
        <v-card flat>
          <v-card-text v-text="text"></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items> -->
    <!-- <v-toolbar class="toolbar" color="#02092E" height="54" flat>
       <v-tabs
          v-model="tab"
          align-with-title
        >
          <v-tabs-slider color="yellow"></v-tabs-slider>

          <v-tab
            v-for="item in ['foo', 'bar', 'baz']"
            :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
      <v-list class="tabs-wrapper" height="44">
        <v-list-item-group class="d-flex" v-model="selectedTab" mandatory>
          <v-list-item
            v-for="(tab, i) in tabs" :key="`tab-${i}`"
            :value="tab.name"
            @click="$router.push({ name: tab.link })"
            class="tab flex text-center font-size-medium-large"
            active-class="selected-tab">
            <span class="ma-auto"
                  :class="{'white--text': tab.name !== selectedTab}">
              {{tab.title}}
            </span>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-spacer/>
      <div class="d-inline-flex">
        <v-btn @click="showLogoutDialog()" class="logout-modal-button">
          Log out
        </v-btn>
        <a href="https://covatic.com/" target="_blank" rel="noopener noreferrer">
          <v-img :src="cvcIcon" contain width="150px" height="50px"/>
        </a>
      </div>
    </v-toolbar> -->

    <logout-modal ref="logoutModal" />
  </div>
</template>

<script>
import LogoutModal from "@/components/LogoutModal";

export default {
  components: { LogoutModal },
  data() {
    return {
      cvcIcon: require("../assets/Covatic.png"),
      tab: 0,
      tabs: [
        { title: "Insights", name: "Insights", link: "Insights" },
        {
          title: "Notifications",
          name: "Notifications",
          link: "NotificationsBuilder",
        },
        {
          title: "Advertising",
          name: "Advertising",
          link: "AdvertisingEstimator",
        },
      ],
    };
  },
  computed: {
    selectedTab: {
      get() {
        return this.$route.matched[1].name;
      },
      set() {},
    },
  },
  methods: {
    showLogoutDialog() {
      this.$refs.logoutModal.showDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  position: relative;
  width: 100%;
  z-index: 991;
}
.tabs-wrapper {
  position: absolute;
  display: flex;
  bottom: 0;
  padding: 0;
  background: none !important;
}
.tab {
  display: flex;
  margin: 0 8px;
  background-color: #1f6ada;
  min-height: 44px !important;
  height: 44px;
  width: 270px;
}
.selected-tab {
  color: #02092e !important;
  background-color: white !important;
  &:before {
    color: #02092e !important;
    background-color: white !important;
  }
}
.logout-modal-button {
  height: 50px !important;
  text-transform: none;
  width: 100px;
  color: white;
  background: none !important;
  font-size: 18px;
}
</style>
